import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

import { absenceApi, TGetAllAbsenceResponse } from 'app/services/edpApiV1/absence';
import { TAbsentInfo } from 'shared/types/absence.types';

type TInitialState = {
  data: TAbsentInfo[] | null;
  pagination: {
    size: number;
    page: number;
    total: number;
  } | null;
};

const initialState: TInitialState = {
  data: null,
  pagination: null,
};

export const absenceSlice = createSlice({
  name: 'absence',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        absenceApi.endpoints.getAllAbsence.matchFulfilled,
        (state, { payload }: PayloadAction<TGetAllAbsenceResponse>) => payload,
      )
      .addMatcher(absenceApi.endpoints.getAllAbsence.matchRejected, () => initialState);
  },
});

const absence = (state: RootState) => state.entities.absence;
const getAbsence = createSelector(absence, state => state);

export const selectors = { getAbsence };
export const actions = absenceSlice.actions;
export const reducer = absenceSlice.reducer;
